module.exports = __webpack_public_path__ + "static/media/nasal_pillow.c75c6138.png";